import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import TenantUserListForm from '@src/features/tenant/tenant-user/TenantUserListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function TenantUserList() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <TenantUserListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default TenantUserList;
